import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Users',
    data () {
        return {
            admin:{},
            users: {},
            wallet_transactions:{},
            wallet_transaction:{},
            total_wallet_balance:0,
            disable_btn:false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
       

    //wallet
    setWalletTransaction(txn){
        this.wallet_transaction = txn;
    },
    
    getWalletTransactions() {
        service.getWalletTransactions(this).then(data => {
             if(data.body.status == 200) {
                 this.total_wallet_balance = data.body.total_wallet_balance;
             }
             this.wallet_transactions = data.body.data;
         }).catch((err) => {
             if(err) {
                 toastr.error('Sorry, could not process information', 'Warning!');
             }
         })
    },

    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        return currency.replace("NGN", ""); //strip off NGN
    },

    
    //wallet

    
        
    },
    created: function(){
        this.preset();
        this.getWalletTransactions();
    }
}


// WEBPACK FOOTER //
// ./src/components/CNwallets/script.js